import React from 'react';
import { message } from 'antd';
import infoSvg from 'src/assets/messageIcon/info.svg';
import errorSVG from 'src/assets/messageIcon/error.svg';
import successSVG from 'src/assets/messageIcon/success.svg';

interface messageProps {
  content: string
  duration?: number
}

export const MessageSuccess = (prop: messageProps) => {
  const { content = '', duration = 3 } = prop;
  message.success({
    content,
    duration,
    icon: <img src={successSVG} alt="Success" />
  });
};

export const MessageError = (prop: messageProps) => {
  const { content = '', duration = 3 } = prop;
  message.error({
    content,
    duration,
    icon: <img src={errorSVG} alt="Error" />
  });
};

export const MessageInfo = (prop: messageProps) => {
  const { content = '', duration = 3 } = prop;
  message.info({
    content,
    duration,
    icon: <img src={infoSvg} alt="Error" />
  });
};
